import logging from '@sstdev/lib_logging';
import { BbState } from 'lib_ui-primitives';
import { rfidStrategy } from 'lib_ui-services';
import baseRule from '../../namespace/relation/willUpdate_namespace_relation';

export const _private = { BbState };
const { STRATEGY_TYPES } = rfidStrategy;

export default {
    verb: 'willUpdate',
    namespace: 'identity',
    relation: 'tenantSetting',
    description: 'expand "simple" (toggle) settings to more expansive ones that include more information.',
    priority: baseRule.priority + 10, // run before the base rule
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 *
 * @typedef {import('@sstdev/types').TenantSettings} TenantSettings
 */

/**
 * @param {{
 *   data: {newRecord: TenantSettings, oldRecord?: TenantSettings};
 *   prerequisiteResults?: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise<{newRecord:TenantSettings}>}
 */
async function logic({ data, dispatch }) {
    try {
        const { useGs1, displayInAscii } = data.newRecord;
        const prevTenantSetting = data.oldRecord || { useGs1: undefined, displayInAscii: undefined };

        // if either rfid toggle was changed, we need to update the rfid config
        if (useGs1 != prevTenantSetting.useGs1 || displayInAscii != prevTenantSetting.displayInAscii) {
            let rfid = data.newRecord.rfid || {};
            if (useGs1) {
                rfid.shortStrategy = STRATEGY_TYPES.GS1;
                rfid.longStrategy = STRATEGY_TYPES.GS1;
                rfid.maxShortLength = 24;
                rfid.displayStrategy = STRATEGY_TYPES.GS1;
            } else if (displayInAscii) {
                // if displayInAscii is true, we need to set the shortStrategy to ASCII
                rfid.shortStrategy = STRATEGY_TYPES.ASCII;
                rfid.longStrategy = STRATEGY_TYPES._ID;
                rfid.maxShortLength = 12;
                rfid.displayStrategy = STRATEGY_TYPES.ASCII;
            } else {
                rfid.shortStrategy = STRATEGY_TYPES.HEX;
                rfid.longStrategy = STRATEGY_TYPES._ID;
                rfid.maxShortLength = 24;
                rfid.displayStrategy = STRATEGY_TYPES.HEX;
            }
            data.newRecord.rfid = rfid;

            const message = ['Existing data will not be altered or validated for the new setting.'];
            dispatch(
                {
                    title: 'Updating Tag Settings',
                    message,
                    okButtonText: 'OK',
                    icon: 'info',
                    noCancelOption: true,
                    okAction: () => {}
                },
                { verb: 'confirm', namespace: 'application', relation: 'user' }
            );
        }
    } catch (err) {
        logging.error(err);
    }
    return data;
}
